import { useMemo } from "react"
import { IModalWrapper } from "@/ui/Modal"
import { useModalsContext } from "../ModalsProvider.tsx"
import { ModalType } from "../types.ts"

export const useModals = () => {
  const context = useModalsContext()

  if (!context) {
    throw new Error("useModals must be used within a ModalProvider")
  }

  return context
}

export const useModal = (type: ModalType) => {
  const modalContext = useModals()

  const { modals, closeModal, getModalParams, setModalConfig, getModalConfig } =
    modalContext

  const modalConfig = getModalConfig(type)

  const handleClose = () => {
    closeModal(type, modalConfig?.onClose)
  }

  const handleSetModalConfig = (config: IModalWrapper) => {
    setModalConfig(type, config)
  }

  const modal = useMemo(() => {
    if (!modals[type]) return null

    return {
      isOpen: modals[type],
      params: getModalParams(type),
      close: handleClose,
      setConfig: handleSetModalConfig,
      config: modalConfig
    }
  }, [modals, type])

  if (!modal) {
    throw new Error(`Modal ${type} is not found`)
  }

  return {
    ...modalContext,
    modal
  }
}
